module.exports = __webpack_public_path__ + "static/media/LineCopy.7781cfd6.svg";